export default __webpack_public_path__ + "static/media/Mohamed Akmal.6c5d910a.jpeg";